class Authentication {
  constructor(localStorageService) {
    "ngInject";

    this.localStorageService = localStorageService;
    this.storageKey = "authdata";
  }

  authenticate(response) {
    const token = response.token;
    const refreshToken = response.refresh_token;
    const creationDate = response.createdAt;
    const expirationDate = response.expiry_date;
    const owner = response.owner;
    const jwt = response.jwt;
    const role = response.role;
    const roles = response.roles;

    this._setInLocalStorage({
      token,
      refreshToken,
      creationDate,
      expirationDate,
      owner,
      jwt,
      role,
      roles,
    });
  }

  getValue(name) {
    const storedValue = this.localStorageService.get(this.storageKey);

    return storedValue ? storedValue[name] : null;
  }

  getRefreshToken() {
    return this.getValue("refreshToken");
  }

  getRole() {
    return this.getValue("role");
  }

  getOwner() {
    return this.getValue("owner");
  }

  updateToken(response) {
    this.authenticate(response);
  }

  _setInLocalStorage(authdata) {
    this.localStorageService.set(this.storageKey, authdata);
  }
}

export default Authentication;



// WEBPACK FOOTER //
// ./src/services/authentication/authentication.service.js